import styled, {css} from "styled-components"
import {SvgCard} from "@irati/ui/src/Layout"

export const StyledTemplate = styled.div`
  color: ${({theme}) => theme.colors.greys.dark};
  cursor: pointer;
  padding: ${({theme}) => theme.spacing.four} ${({theme}) => theme.spacing.one};
  position: relative;
  text-align: center;
`

interface StyledSvgCardProps {
  isSelected: boolean
}

export const StyledSvgCard = styled(SvgCard)<StyledSvgCardProps>`
  ${({theme, isSelected}) => css`
    border-radius: ${theme.border.radius.medium};
    opacity: ${isSelected ? 1 : 0.5};
    overflow: hidden;
    flex: 1;
    width: 120px;
  `}
`

export const PickFromLibraryIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({theme}) => theme.colors.greys.white};
  border-radius: 50px;
  height: 30px;
  width: 30px;
`

export const PickFromLibraryStyledCardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  color: ${({theme}) => theme.colors.greys.dark};
  padding: ${({theme}) => theme.spacing.oneAndHalf};
  cursor: pointer;
`

export const IconWrapper = styled.div`
  background: ${({theme}) => theme.colors.greys.white};
  border-radius: 50px;
  height: 50px;
  margin: 0 auto;
  padding-top: 12px;
  text-align: center;
  width: 50px;
`

export const StyledFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`

export const StyledDiv = styled.div`
  color: ${({theme}) => theme.colors.greys.dark};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 50%;
  position: relative;
  text-align: center;
  width: 100%;
`

export const StyledWrapper = styled.div`
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgba(61, 61, 54, 0.25);
  height: calc(100% + 70px);
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
`
